import React, { useEffect, useState } from 'react';
import styles from './Home.module.scss';
import CustomButton from '../../components/Button';
import { InformData } from './InformData';
import InformModal from './Modals/InformModal';
import { Button, Modal, Tabs } from 'antd';
import TabInform from '../Quiz/Program_Menu/Tab_Inform';
import { tabs } from '../quizData/tabs';
import { useDispatch, useSelector } from 'react-redux';
import { useReducerData } from '../../store/hooks';

//Actions
import { attemptSetTab, getActivitiesListAction } from '../../store/actions/quizActions';
import { checkSubscriptionApi } from '../../store/actions/subscriptionActions';

import { isLoggedIn } from '../../helpers/utility';
import cs from 'classnames';
import { useNavigate } from 'react-router';
import Cookies from 'js-cookie';

const { TabPane } = Tabs;

const programPriority = {
  'Figure 8 activity': 1,
  'Direction Charts': 1,
  'Speed Number Counting': 2,
  'Number Quiz': 2,
  'Colour coded memory cards': 2,
  'Final Quiz': 2,
  'Reward Chart': 2,
  'Number Families': 2,
  'Finger Skip Counting': 2,
  'Brain Warrior Workout': 3,
};
const priorityTitles = [
  'Number Quiz',
  'Speed Number Counting',
  'Final Quiz',
  'Number Families',
  'Colour coded memory cards',
  'Reward Chart',
];

const Home = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isCall, setIsCall] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const { user } = useSelector((state) => state.auth);
  const [programName, setProgramName] = useState('');
  const dispatch = useDispatch();
  const tabKey = useReducerData('quiz', 'tabKey' || '0');
  const modelTitle = useReducerData('quiz', 'modelTitle');
  const [getIsUnitName, setIsunitName] = useState('Addition Unit');
  const currentActivityremaining = useReducerData('quiz', 'activitiesData');
  const lastActivities = useReducerData('quiz', 'lastActivitiesData');
  const routeWhenAllValueTrue = Object.values(currentActivityremaining?.activities || {});

  const onChange = async (key) => {
    setIsCall(true);
    const findUnitType = tabs.find((val) => val.tab.key == key);
    setIsunitName(findUnitType.tab.type);
    await dispatch(attemptSetTab(key));
  };
  const modelHandle = () => {
    if (priorityTitles.includes(modelTitle)) {
      return 2;
    }

    if (programName) {
      scrollToCard();
      return programPriority[programName];
    }

    if (modelTitle === 'Figure 8 activity' || modelTitle === 'Direction Charts') {
      return 1;
    }
    if (modelTitle === 'Brain Warrior Workout') {
      return 3;
    }
  };

  const scrollToCard = (index) => {
    const serviceToScroll = document.getElementById(`info_card_${index}`);
    serviceToScroll?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    setTimeout(() => {
      if (isLoggedIn() && user?.user_type !== 'Admin') {
        dispatch(checkSubscriptionApi());
      }
    }, 1000);
  }, [user]);

  useEffect(() => {
    if (isCall) {
      setTimeout(() => {
        if (isLoggedIn()) {
          dispatch(getActivitiesListAction(getIsUnitName));
        }
      }, 1000);
    }
  }, [getIsUnitName]);

  const token = sessionStorage.getItem('token') || Cookies.get('token');
  useEffect(() => {
    if (!token) {
      setIsVisible(false);
    }
    if (
      !routeWhenAllValueTrue.length ||
      routeWhenAllValueTrue.every((value) => value === true) ||
      routeWhenAllValueTrue.every((value) => value === false)
    ) {
      return;
    }
    const hasReloaded = sessionStorage.getItem('hasReloadeds');
    if (!hasReloaded && isLoggedIn()) {
      setIsVisible(true);
    }
  }, [routeWhenAllValueTrue, token]);

  useEffect(() => {
    const hasReloaded = sessionStorage.getItem('hasReloadeds');
    if (!hasReloaded) {
      setTimeout(() => {
        const { unit_name } = lastActivities;
        if (unit_name && isLoggedIn()) {
          dispatch(getActivitiesListAction(unit_name));
        }
      }, 0);
    }
  }, [lastActivities]);

  const handleYes = () => {
    sessionStorage.setItem('hasReloadeds', 'true');
    const transformedActivities = currentActivityremaining?.activities;
    const keys = Object.keys(transformedActivities);
    handleOnChange(lastActivities?.unit_name);
    const currentIndex = keys.indexOf(lastActivities?.activity_title);
    let nextKey = keys.slice(currentIndex + 1).find((key) => transformedActivities[key] === false);
    if (nextKey === undefined) {
      nextKey = keys.find((key) => transformedActivities[key] === false);
    }
    if (nextKey) {
      navigate(`/activities/${nextKey}`);
    } else {
      navigate(`/`);
    }
  };

  const handleSkip = () => {
    sessionStorage.setItem('hasReloadeds', 'true');
    dispatch(getActivitiesListAction('Addition Unit'));
    const unitMapping = {
      'Addition Unit': '0',
      'Subtraction Unit': '1',
      'Multiplication Unit': '2',
      'Division Unit': '3',
    };
    // onChange(unitMapping[lastActivities?.unit_name] || '0');
    // dispatch(attemptSetTab(unitMapping[lastActivities?.unit_name]));
    setIsVisible(false);
  };
  const handleOnChange = (unitName) => {
    sessionStorage.setItem('hasReloadeds', 'true');
    const unitMapping = {
      'Addition Unit': '0',
      'Subtraction Unit': '1',
      'Multiplication Unit': '2',
      'Division Unit': '3',
    };
    onChange(unitMapping[unitName] || '0');
    dispatch(attemptSetTab(unitMapping[unitName]));
  };

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.infoContainer}>
          {InformData.map((element, index) => {
            return (
              <div
                className={cs(styles.detailContainer, {
                  [styles.modelHighlight]: modelHandle() === index,
                })}
                key={index}
                id={`info_card_${index}`}
                onClick={scrollToCard(index)}
              >
                <div className={styles.imageContainer}>
                  <img src={element.image} width="100%" alt={element.image} />
                </div>
                <div className={styles.detailMainContainer}>
                  <div className={styles.headingContainer}>
                    <span>{element.text}</span>
                  </div>
                  <div className={styles.subTextContainer}>
                    <span>{element.subText}</span>
                  </div>
                </div>

                <div className={styles.buttonContainer}>
                  <CustomButton
                    type="primary"
                    onClick={() => {
                      setIsModalVisible(true);
                      setModalIndex(index);
                    }}
                  >
                    Read more
                  </CustomButton>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.ProgramsMainContainer}>
          <div className={styles.programContainer}>
            <div className={styles.heading}>
              <span>Math program</span>
            </div>
            <div className={styles.tabContainer}>
              <Tabs defaultActiveKey="0" activeKey={tabKey} onChange={onChange} centered>
                {tabs.map((tabData, i) => (
                  <TabPane tab={tabData?.tab?.type} key={i}>
                    <TabInform tabKey={tabKey} setProgramName={setProgramName} tabDataType={tabData.tab} />
                  </TabPane>
                ))}
              </Tabs>
            </div>
          </div>
          <div className={styles.informationContainer}>
            All young learners will be capable of acquiring their basic numeracy skills in a multi-sensory, fun,
            activity based Math program, specifically designed for youthful, active students including students with
            Language Based Learning Disabilities, particularly ADD/ADHD and Spectrum learners.
          </div>
        </div>
      </div>

      <InformModal isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} modalIndex={modalIndex} />
      <Modal
        title="Confirm Modal"
        open={isVisible}
        onCancel={() => {
          sessionStorage.setItem('hasReloadeds', 'true');
          // handleOnChange(lastActivities?.unit_name);
          dispatch(getActivitiesListAction('Addition Unit'));
          setIsVisible(false);
        }}
        footer={null}
      >
        <p>Do you want to start where you left</p>
        <Button type="primary" onClick={handleYes}>
          Yes
        </Button>
        <Button type="default" onClick={handleSkip} style={{ marginLeft: '10px' }}>
          Skip
        </Button>
      </Modal>
    </>
  );
};

export default Home;
